import { call, put } from "redux-saga/effects";
import {
  searchStores,
  getSearchSuggestions,
  getNearbyLocationsOffers,
  getRecentSearches,
} from "../../api/searchApi";
import { Types } from "../actionTypes";

export function* doSearch(action) {
  try {
    let response = yield call(searchStores, action.params);
    let didResetSubCategory = false;

    const isSubCatSearch = !!action.params.selectedSubCategory.id;

    // resets to parent category if subcategory has no results
    if (!!action.params.selectedSubCategory.id && response.info.total_results === 0) {
      action.params.selectedSubCategory = {};
      // TODO: See about removing needless second API call here
      // or adjust offerFilter check?
      response = yield call(searchStores, action.params);
      didResetSubCategory = true;
    }

    yield put({
      type: Types.FETCH_SEARCH_RESULTS_SUCCESS,
      response,
      isSubCatSearch,
      didResetSubCategory,
    });

    if (action.params.futureSubCategory) {
      yield put({
        type: Types.SELECT_SUB_CATEGORY,
        id: action.params.futureSubCategory,
      });
    }
  } catch (error) {
    yield put({ type: Types.FETCH_SEARCH_RESULTS_FAILURE, error });
    if (error.data?.message === "SESSION_EXPIRED") {
      yield put({ type: Types.SET_SESSION_EXPIRED });
    } else {
      console.log("error: ", error);
    }
  }
}

export function* getNearbyLocationsOffersSaga(action) {
  try {
    const data = yield call(getNearbyLocationsOffers, action.payload);

    yield put({
      type: Types.GET_NEARBY_LOCATIONS_OFFERS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({ type: Types.GET_NEARBY_LOCATIONS_OFFERS_FAILURE, error });
    if (error.data?.message === "SESSION_EXPIRED") {
      yield put({ type: Types.SET_SESSION_EXPIRED });
    } else {
      console.log("error: ", error);
    }
  }
}

export function* fetchSearchSuggestions(action) {
  try {
    const response = yield call(getSearchSuggestions, action.term);
    yield put({ type: Types.FETCH_SEARCH_SUGGESTIONS_SUCCESS, response });
  } catch (error) {
    yield put({ type: Types.FETCH_SEARCH_SUGGESTIONS_FAILURE, error });
    if (error.data?.message === "SESSION_EXPIRED") {
      yield put({ type: Types.SET_SESSION_EXPIRED });
    } else {
      console.log("error: ", error);
    }
  }
}

export function* fetchRecentSearches() {
  try {
    const response = yield call(getRecentSearches);
    yield put({ type: Types.FETCH_RECENT_SEARCHES_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: Types.FETCH_RECENT_SEARCHES_FAILURE, error });
    console.error(error);
  }
}
